import { render, staticRenderFns } from "./editInventory.vue?vue&type=template&id=1128a370&"
import script from "./editInventory.vue?vue&type=script&lang=js&"
export * from "./editInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports